import { z } from "zod/v4-mini";

import { Schema, cz } from "@/utils/zodUtils.ts";

/**
 * Result of the duplicate check run before including a patient:
 * the api looks the patient up by email *and* phone number.
 */
export type ExistingPatientStatus = "not_found" | "monitored_by_me" | "monitored_by_other";

/** The statuses that block the inclusion — everything but `not_found`. */
export type ExistingPatientConflict = Exclude<ExistingPatientStatus, "not_found">;

export const existingPatientStatusSchema: Schema<ExistingPatientStatus> = z.literal([
  "not_found",
  "monitored_by_me",
  "monitored_by_other",
]);

export type ExistingPatient = {
  status: ExistingPatientStatus;
  /** Only returned for `monitored_by_me` — another doctor's patient is never disclosed. */
  patientId?: string;
};

export const existingPatientSchema: Schema<ExistingPatient> = cz.camelCaseObject({
  status: existingPatientStatusSchema,
  patient_id: cz.optional(cz.id()),
});

export type ExistingPatientQuery = {
  email: string;
  phone: string;
};

export const existingPatientConflictTranslationMapping = (status: ExistingPatientConflict): string => {
  switch (status) {
    case "monitored_by_me":
      return "diabetesForms.existingPatient.monitoredByMe";
    case "monitored_by_other":
      return "diabetesForms.existingPatient.monitoredByOther";
  }
};
